import { IconBold } from '@xing-com/icons';

import * as Styled from '../styles';
import type { ToolProps } from '../types';

export const BoldTool: React.FC<ToolProps> = ({ editor, disabled }) => {
  return (
    <Styled.ToolBarButton
      onClick={() => editor.chain().focus().toggleBold().run()}
      disabled={disabled || !editor.can().chain().focus().toggleBold().run()}
      className={editor.isActive('bold') ? 'is-active' : ''}
    >
      <IconBold width={24} height={24} />
    </Styled.ToolBarButton>
  );
};
